<template>
	<v-breadcrumbs
		:items="items"
		large
		class="breadcrumbs ps-0 py-0"
	>
		<template v-slot:divider>
			<v-icon size="18">mdi-chevron-left</v-icon>
		</template>
		<template v-slot:item="{ item }">
			<v-breadcrumbs-item
				exact
				active-class="font-weight-bold black--text"
				:to="item.to"
				:disabled="item.disabled"
			>
				<v-icon v-if="item.icon" size="20" class="me-2">{{item.icon}}</v-icon>
				<v-img v-else-if="item.img" :src="item.img" width="20" height="20" class="me-1"/>
				{{ item.text }}
			</v-breadcrumbs-item>
		</template>
	</v-breadcrumbs>
</template>

<script>
export default {
	name: 'Breadcrumbs',
	props: {
		items: { type: Array, default: () => [] }
	}
}
</script>

<style lang="scss">
.breadcrumbs {
	.v-breadcrumbs {
		&__item {
			color: #333;
			&--disabled {
				color: black;
				font-weight: 600;
			}
		}
	}
}
</style>